const passThroughClicks = { pointerEvents: "none" };

const ScratchIsland = ({
  windowDimensions,
  scale = 1,
  className,
  onClick = () => {},
  style = {},
}) => (
  <svg
    width={windowDimensions.width * windowDimensions.zoom}
    height={windowDimensions.height * windowDimensions.zoom}
    viewBox={`0 0 ${601 * scale} ${801 * scale}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
    className={className}
    style={style}
  >
    <mask
      id="path-1-outside-1"
      maskUnits="userSpaceOnUse"
      x="140.309"
      y="190.366"
      width="320"
      height="420"
      fill="black"
    >
      <rect fill="white" x="140.309" y="190.366" width="320" height="420" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M450.309 220.366C450.309 209.321 441.355 200.366 430.309 200.366L370.309 200.366C359.263 200.366 350.309 209.321 350.309 220.366V300.366H270.309C259.263 300.366 250.309 309.321 250.309 320.366V373.344V380.366V400.366H170.309C159.263 400.366 150.309 409.321 150.309 420.366V580.366C150.309 591.412 159.263 600.366 170.309 600.366H330.309C341.355 600.366 350.309 591.412 350.309 580.366V428.096V420.366V400.366H370.309H430.309C441.355 400.366 450.309 391.412 450.309 380.366V320.366V220.366Z"
      />
    </mask>
    <path
      d="M430.309 200.366V210.366V200.366ZM370.309 200.366V190.366V200.366ZM350.309 300.366V310.366H360.309V300.366H350.309ZM250.309 400.366V410.366H260.309V400.366H250.309ZM350.309 400.366V390.366H340.309V400.366H350.309ZM430.309 210.366C435.832 210.366 440.309 214.843 440.309 220.366H460.309C460.309 203.798 446.878 190.366 430.309 190.366V210.366ZM370.309 210.366L430.309 210.366V190.366L370.309 190.366V210.366ZM360.309 220.366C360.309 214.843 364.786 210.366 370.309 210.366V190.366C353.741 190.366 340.309 203.798 340.309 220.366H360.309ZM360.309 300.366V220.366H340.309V300.366H360.309ZM270.309 310.366H350.309V290.366H270.309V310.366ZM260.309 320.366C260.309 314.843 264.786 310.366 270.309 310.366V290.366C253.741 290.366 240.309 303.798 240.309 320.366H260.309ZM260.309 373.344V320.366H240.309V373.344H260.309ZM260.309 380.366V373.344H240.309V380.366H260.309ZM260.309 400.366V380.366H240.309V400.366H260.309ZM170.309 410.366H250.309V390.366H170.309V410.366ZM160.309 420.366C160.309 414.843 164.786 410.366 170.309 410.366V390.366C153.741 390.366 140.309 403.798 140.309 420.366H160.309ZM160.309 580.366V420.366H140.309V580.366H160.309ZM170.309 590.366C164.786 590.366 160.309 585.889 160.309 580.366H140.309C140.309 596.935 153.741 610.366 170.309 610.366V590.366ZM330.309 590.366H170.309V610.366H330.309V590.366ZM340.309 580.366C340.309 585.889 335.832 590.366 330.309 590.366V610.366C346.878 610.366 360.309 596.935 360.309 580.366H340.309ZM340.309 428.096V580.366H360.309V428.096H340.309ZM340.309 420.366V428.096H360.309V420.366H340.309ZM340.309 400.366V420.366H360.309V400.366H340.309ZM370.309 390.366H350.309V410.366H370.309V390.366ZM430.309 390.366H370.309V410.366H430.309V390.366ZM440.309 380.366C440.309 385.889 435.832 390.366 430.309 390.366V410.366C446.878 410.366 460.309 396.935 460.309 380.366H440.309ZM440.309 320.366V380.366H460.309V320.366H440.309ZM440.309 220.366V320.366H460.309V220.366H440.309Z"
      fill="#0B6FFB"
      mask="url(#path-1-outside-1)"
    />
    <mask id="path-3-inside-2" fill="white">
      <path d="M150.309 420.366C150.309 409.321 159.263 400.366 170.309 400.366H330.309C341.355 400.366 350.309 409.321 350.309 420.366V580.366C350.309 591.412 341.355 600.366 330.309 600.366H170.309C159.263 600.366 150.309 591.412 150.309 580.366V420.366Z" />
    </mask>
    <path
      d="M150.309 420.366C150.309 409.321 159.263 400.366 170.309 400.366H330.309C341.355 400.366 350.309 409.321 350.309 420.366V580.366C350.309 591.412 341.355 600.366 330.309 600.366H170.309C159.263 600.366 150.309 591.412 150.309 580.366V420.366Z"
      fill="#8F613C"
    />
    <path
      d="M170.309 402.366H330.309V398.366H170.309V402.366ZM348.309 420.366V580.366H352.309V420.366H348.309ZM330.309 598.366H170.309V602.366H330.309V598.366ZM152.309 580.366V420.366H148.309V580.366H152.309ZM170.309 598.366C160.368 598.366 152.309 590.307 152.309 580.366H148.309C148.309 592.516 158.159 602.366 170.309 602.366V598.366ZM348.309 580.366C348.309 590.307 340.25 598.366 330.309 598.366V602.366C342.459 602.366 352.309 592.516 352.309 580.366H348.309ZM330.309 402.366C340.25 402.366 348.309 410.425 348.309 420.366H352.309C352.309 408.216 342.459 398.366 330.309 398.366V402.366ZM170.309 398.366C158.159 398.366 148.309 408.216 148.309 420.366H152.309C152.309 410.425 160.368 402.366 170.309 402.366V398.366Z"
      fill="black"
      mask="url(#path-3-inside-2)"
    />
    <mask id="path-5-inside-3" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M450.309 220.366C450.309 209.321 441.355 200.366 430.309 200.366L370.309 200.366C359.263 200.366 350.309 209.321 350.309 220.366V300.366H270.309C259.263 300.366 250.309 309.321 250.309 320.366V380.366C250.309 391.412 259.263 400.366 270.309 400.366H370.309H430.309C430.999 400.366 431.682 400.331 432.354 400.263C442.439 399.239 450.309 390.722 450.309 380.366L450.309 320.366C450.309 320.36 450.309 320.353 450.309 320.346L450.309 220.366Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M450.309 220.366C450.309 209.321 441.355 200.366 430.309 200.366L370.309 200.366C359.263 200.366 350.309 209.321 350.309 220.366V300.366H270.309C259.263 300.366 250.309 309.321 250.309 320.366V380.366C250.309 391.412 259.263 400.366 270.309 400.366H370.309H430.309C430.999 400.366 431.682 400.331 432.354 400.263C442.439 399.239 450.309 390.722 450.309 380.366L450.309 320.366C450.309 320.36 450.309 320.353 450.309 320.346L450.309 220.366Z"
      fill="#8F613C"
    />
    <path
      d="M430.309 200.366V202.366V200.366ZM450.309 220.366H452.309H450.309ZM370.309 200.366V198.366V200.366ZM350.309 300.366V302.366H352.309V300.366H350.309ZM432.354 400.263L432.152 398.273L432.354 400.263ZM450.309 380.366H448.309H450.309ZM450.309 320.366L452.309 320.366V320.366H450.309ZM450.309 320.346H448.309H450.309ZM430.309 202.366C440.25 202.366 448.309 210.425 448.309 220.366H452.309C452.309 208.216 442.459 198.366 430.309 198.366V202.366ZM370.309 202.366L430.309 202.366V198.366L370.309 198.366V202.366ZM352.309 220.366C352.309 210.425 360.368 202.366 370.309 202.366V198.366C358.159 198.366 348.309 208.216 348.309 220.366H352.309ZM352.309 300.366V220.366H348.309V300.366H352.309ZM270.309 302.366H350.309V298.366H270.309V302.366ZM252.309 320.366C252.309 310.425 260.368 302.366 270.309 302.366V298.366C258.159 298.366 248.309 308.216 248.309 320.366H252.309ZM252.309 380.366V320.366H248.309V380.366H252.309ZM270.309 398.366C260.368 398.366 252.309 390.307 252.309 380.366H248.309C248.309 392.516 258.159 402.366 270.309 402.366V398.366ZM370.309 398.366H270.309V402.366H370.309V398.366ZM430.309 398.366H370.309V402.366H430.309V398.366ZM432.152 398.273C431.547 398.335 430.932 398.366 430.309 398.366V402.366C431.067 402.366 431.817 402.328 432.556 402.253L432.152 398.273ZM448.309 380.366C448.309 389.685 441.226 397.352 432.152 398.273L432.556 402.253C443.652 401.126 452.309 391.758 452.309 380.366H448.309ZM448.309 320.366L448.309 380.366H452.309L452.309 320.366L448.309 320.366ZM448.309 320.346C448.309 320.351 448.309 320.356 448.309 320.359C448.309 320.362 448.309 320.364 448.309 320.366H452.309C452.309 320.362 452.309 320.357 452.309 320.354C452.309 320.351 452.309 320.348 452.309 320.346H448.309ZM448.309 220.366L448.309 320.346H452.309L452.309 220.366H448.309Z"
      fill="black"
      mask="url(#path-5-inside-3)"
    />
    <mask id="path-7-inside-4" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M450.309 170.366C450.309 159.321 441.355 150.366 430.309 150.366L370.309 150.366C359.263 150.366 350.309 159.321 350.309 170.366V250.366H270.309C259.263 250.366 250.309 259.321 250.309 270.366V323.344V330.366V350.366H170.309C159.263 350.366 150.309 359.321 150.309 370.366V530.366C150.309 541.412 159.263 550.366 170.309 550.366H330.309C341.355 550.366 350.309 541.412 350.309 530.366V378.096V370.366V350.366H370.309H430.309C441.355 350.366 450.309 341.412 450.309 330.366V270.366V170.366Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M450.309 170.366C450.309 159.321 441.355 150.366 430.309 150.366L370.309 150.366C359.263 150.366 350.309 159.321 350.309 170.366V250.366H270.309C259.263 250.366 250.309 259.321 250.309 270.366V323.344V330.366V350.366H170.309C159.263 350.366 150.309 359.321 150.309 370.366V530.366C150.309 541.412 159.263 550.366 170.309 550.366H330.309C341.355 550.366 350.309 541.412 350.309 530.366V378.096V370.366V350.366H370.309H430.309C441.355 350.366 450.309 341.412 450.309 330.366V270.366V170.366Z"
      fill="#FFC700"
      {...passThroughClicks}
    />
    <path
      d="M430.309 150.366V152.366V150.366ZM370.309 150.366V148.366V150.366ZM350.309 250.366V252.366H352.309V250.366H350.309ZM250.309 350.366V352.366H252.309V350.366H250.309ZM350.309 350.366V348.366H348.309V350.366H350.309ZM430.309 152.366C440.25 152.366 448.309 160.425 448.309 170.366H452.309C452.309 158.216 442.459 148.366 430.309 148.366V152.366ZM370.309 152.366L430.309 152.366V148.366L370.309 148.366V152.366ZM352.309 170.366C352.309 160.425 360.368 152.366 370.309 152.366V148.366C358.159 148.366 348.309 158.216 348.309 170.366H352.309ZM352.309 250.366V170.366H348.309V250.366H352.309ZM270.309 252.366H350.309V248.366H270.309V252.366ZM252.309 270.366C252.309 260.425 260.368 252.366 270.309 252.366V248.366C258.159 248.366 248.309 258.216 248.309 270.366H252.309ZM252.309 323.344V270.366H248.309V323.344H252.309ZM252.309 330.366V323.344H248.309V330.366H252.309ZM252.309 350.366V330.366H248.309V350.366H252.309ZM170.309 352.366H250.309V348.366H170.309V352.366ZM152.309 370.366C152.309 360.425 160.368 352.366 170.309 352.366V348.366C158.159 348.366 148.309 358.216 148.309 370.366H152.309ZM152.309 530.366V370.366H148.309V530.366H152.309ZM170.309 548.366C160.368 548.366 152.309 540.307 152.309 530.366H148.309C148.309 542.516 158.159 552.366 170.309 552.366V548.366ZM330.309 548.366H170.309V552.366H330.309V548.366ZM348.309 530.366C348.309 540.307 340.25 548.366 330.309 548.366V552.366C342.459 552.366 352.309 542.516 352.309 530.366H348.309ZM348.309 378.096V530.366H352.309V378.096H348.309ZM348.309 370.366V378.096H352.309V370.366H348.309ZM348.309 350.366V370.366H352.309V350.366H348.309ZM370.309 348.366H350.309V352.366H370.309V348.366ZM430.309 348.366H370.309V352.366H430.309V348.366ZM448.309 330.366C448.309 340.307 440.25 348.366 430.309 348.366V352.366C442.459 352.366 452.309 342.516 452.309 330.366H448.309ZM448.309 270.366V330.366H452.309V270.366H448.309ZM448.309 170.366V270.366H452.309V170.366H448.309Z"
      fill="black"
      mask="url(#path-7-inside-4)"
    />
    <circle cx="300.309" cy="500.366" r="20" fill="#FFFAE8" id="node-start" />
    <circle
      cx="200.309"
      cy="500.366"
      r="20"
      fill="#FFFAE8"
      id="node-space-talk"
    />
    <circle
      cx="200.309"
      cy="400.366"
      r="20"
      fill="#FFFAE8"
      id="node-catch-the-bus"
    />
    <circle
      cx="300.309"
      cy="400.366"
      r="20"
      fill="#FFFAE8"
      id="node-find-the-bug"
    />
    <circle
      cx="300.309"
      cy="300.366"
      r="20"
      fill="#FFFAE8"
      id="node-silly-eyes"
    />
    <circle
      cx="400.309"
      cy="300.366"
      r="20"
      fill="#FFFAE8"
      id="node-surprise-animation"
    />
    <circle
      cx="400.309"
      cy="200.366"
      r="20"
      fill="#FFFAE8"
      id="node-i-made-you-a-book"
    />
    <rect
      x="200.309"
      y="491.366"
      width="100"
      height="20"
      fill="#FFFAE8"
      {...passThroughClicks}
    />
    <rect
      x="190.309"
      y="501.366"
      width="100"
      height="20"
      transform="rotate(-90 190.309 501.366)"
      fill="#FFFAE8"
      {...passThroughClicks}
    />
    <rect
      x="206.309"
      y="391.366"
      width="100"
      height="20"
      fill="#FFFAE8"
      {...passThroughClicks}
    />
    <rect
      x="310.309"
      y="300.366"
      width="83.6441"
      height="20"
      transform="rotate(90 310.309 300.366)"
      fill="#FFFAE8"
      {...passThroughClicks}
    />
    <rect
      x="400.309"
      y="312.366"
      width="100"
      height="20"
      transform="rotate(-180 400.309 312.366)"
      fill="#FFFAE8"
      {...passThroughClicks}
    />
    <rect
      x="390.309"
      y="301.366"
      width="100"
      height="20"
      transform="rotate(-90 390.309 301.366)"
      fill="#FFFAE8"
      {...passThroughClicks}
    />
    <circle
      cx="300.367"
      cy="400.366"
      r="9"
      fill="#FFC700"
      stroke="black"
      strokeWidth="2"
      {...passThroughClicks}
    />
    <circle
      cx="400.367"
      cy="300.366"
      r="9"
      fill="#FFC700"
      stroke="black"
      strokeWidth="2"
      {...passThroughClicks}
    />
    <circle
      cx="400.309"
      cy="200.366"
      r="9"
      fill="#FFC700"
      stroke="black"
      strokeWidth="2"
      {...passThroughClicks}
    />
    <circle
      cx="200.367"
      cy="500.366"
      r="9"
      fill="#FFC700"
      stroke="black"
      strokeWidth="2"
      {...passThroughClicks}
    />
    <circle
      cx="200.367"
      cy="400.366"
      r="9"
      fill="#FFC700"
      stroke="black"
      strokeWidth="2"
      {...passThroughClicks}
    />
    <circle
      cx="300.367"
      cy="300.366"
      r="9"
      fill="#FFC700"
      stroke="black"
      strokeWidth="2"
      {...passThroughClicks}
    />
    <rect
      x="244.924"
      y="419.729"
      width="10"
      height="50"
      fill="#AA7B55"
      stroke="black"
      strokeWidth="2"
    />
    <rect x="245.924" y="462.729" width="8" height="3" fill="#986F4D" />
    <rect x="245.924" y="456.729" width="8" height="3" fill="#986F4D" />
    <rect x="245.924" y="450.729" width="8" height="3" fill="#986F4D" />
    <rect x="245.924" y="444.729" width="8" height="3" fill="#986F4D" />
    <rect x="245.924" y="438.729" width="8" height="3" fill="#986F4D" />
    <mask
      id="path-34-outside-5"
      maskUnits="userSpaceOnUse"
      x="220.309"
      y="406.366"
      width="60"
      height="48"
      fill="black"
    >
      <rect fill="white" x="220.309" y="406.366" width="60" height="48" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M232.158 449.366L249.924 433.284L267.691 449.366V435.806L259.147 425.652L269.115 434.238L274.54 436.623L269.929 424.153L260.639 420.405L274.54 422.859L265.792 411.751L253.654 409.366L249.924 411.751L246.195 409.366L234.057 411.751L225.309 422.859L239.21 420.405L229.92 424.153L225.309 436.623L230.734 434.238L240.702 425.652L232.158 435.806V449.366Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M232.158 449.366L249.924 433.284L267.691 449.366V435.806L259.147 425.652L269.115 434.238L274.54 436.623L269.929 424.153L260.639 420.405L274.54 422.859L265.792 411.751L253.654 409.366L249.924 411.751L246.195 409.366L234.057 411.751L225.309 422.859L239.21 420.405L229.92 424.153L225.309 436.623L230.734 434.238L240.702 425.652L232.158 435.806V449.366Z"
      fill="#009B47"
    />
    <path
      d="M249.924 433.284L251.267 431.802L249.924 430.587L248.582 431.802L249.924 433.284ZM232.158 449.366H230.158V453.874L233.5 450.849L232.158 449.366ZM267.691 449.366L266.349 450.849L269.691 453.874V449.366H267.691ZM267.691 435.806H269.691V435.076L269.221 434.518L267.691 435.806ZM259.147 425.652L260.452 424.137L257.616 426.94L259.147 425.652ZM269.115 434.238L267.81 435.754L268.036 435.949L268.31 436.069L269.115 434.238ZM274.54 436.623L273.735 438.454L278.051 440.352L276.416 435.93L274.54 436.623ZM269.929 424.153L271.805 423.46L271.498 422.63L270.677 422.299L269.929 424.153ZM260.639 420.405L260.986 418.436L259.89 422.26L260.639 420.405ZM274.54 422.859L274.192 424.828L279.354 425.739L276.111 421.621L274.54 422.859ZM265.792 411.751L267.363 410.514L266.905 409.932L266.178 409.789L265.792 411.751ZM253.654 409.366L254.04 407.404L253.252 407.249L252.577 407.681L253.654 409.366ZM249.924 411.751L248.847 413.436L249.924 414.125L251.002 413.436L249.924 411.751ZM246.195 409.366L247.272 407.681L246.596 407.249L245.809 407.404L246.195 409.366ZM234.057 411.751L233.671 409.789L232.944 409.932L232.485 410.514L234.057 411.751ZM225.309 422.859L223.738 421.621L220.495 425.739L225.657 424.828L225.309 422.859ZM239.21 420.405L239.959 422.26L238.863 418.436L239.21 420.405ZM229.92 424.153L229.172 422.299L228.351 422.63L228.044 423.46L229.92 424.153ZM225.309 436.623L223.433 435.93L221.798 440.352L226.114 438.454L225.309 436.623ZM230.734 434.238L231.539 436.069L231.813 435.949L232.039 435.754L230.734 434.238ZM240.702 425.652L242.232 426.94L239.397 424.137L240.702 425.652ZM232.158 435.806L230.628 434.518L230.158 435.076V435.806H232.158ZM248.582 431.802L230.816 447.883L233.5 450.849L251.267 434.767L248.582 431.802ZM248.582 434.767L266.349 450.849L269.033 447.883L251.267 431.802L248.582 434.767ZM269.691 449.366V435.806H265.691V449.366H269.691ZM269.221 434.518L260.677 424.365L257.616 426.94L266.161 437.093L269.221 434.518ZM257.842 427.168L267.81 435.754L270.42 432.723L260.452 424.137L257.842 427.168ZM268.31 436.069L273.735 438.454L275.345 434.793L269.92 432.408L268.31 436.069ZM276.416 435.93L271.805 423.46L268.053 424.847L272.664 437.317L276.416 435.93ZM270.677 422.299L261.387 418.551L259.89 422.26L269.18 426.008L270.677 422.299ZM260.291 422.375L274.192 424.828L274.887 420.889L260.986 418.436L260.291 422.375ZM276.111 421.621L267.363 410.514L264.221 412.989L272.969 424.096L276.111 421.621ZM266.178 409.789L254.04 407.404L253.268 411.329L265.407 413.714L266.178 409.789ZM252.577 407.681L248.847 410.066L251.002 413.436L254.732 411.051L252.577 407.681ZM245.117 411.051L248.847 413.436L251.002 410.066L247.272 407.681L245.117 411.051ZM234.442 413.714L246.58 411.329L245.809 407.404L233.671 409.789L234.442 413.714ZM226.88 424.096L235.628 412.989L232.485 410.514L223.738 421.621L226.88 424.096ZM238.863 418.436L224.962 420.889L225.657 424.828L239.558 422.375L238.863 418.436ZM230.668 426.008L239.959 422.26L238.462 418.551L229.172 422.299L230.668 426.008ZM227.185 437.317L231.796 424.847L228.044 423.46L223.433 435.93L227.185 437.317ZM229.929 432.408L224.504 434.793L226.114 438.454L231.539 436.069L229.929 432.408ZM239.397 424.137L229.429 432.723L232.039 435.754L242.007 427.168L239.397 424.137ZM233.688 437.093L242.232 426.94L239.172 424.365L230.628 434.518L233.688 437.093ZM234.158 449.366V435.806H230.158V449.366H234.158Z"
      fill="black"
      mask="url(#path-34-outside-5)"
    />
    <rect
      x="394.924"
      y="118.729"
      width="10"
      height="50"
      fill="#AA7B55"
      stroke="black"
      strokeWidth="2"
    />
    <rect x="395.924" y="161.729" width="8" height="3" fill="#986F4D" />
    <rect x="395.924" y="155.729" width="8" height="3" fill="#986F4D" />
    <rect x="395.924" y="149.729" width="8" height="3" fill="#986F4D" />
    <rect x="395.924" y="143.729" width="8" height="3" fill="#986F4D" />
    <rect x="395.924" y="137.729" width="8" height="3" fill="#986F4D" />
    <mask
      id="path-42-outside-6"
      maskUnits="userSpaceOnUse"
      x="370.309"
      y="105.366"
      width="60"
      height="48"
      fill="black"
    >
      <rect fill="white" x="370.309" y="105.366" width="60" height="48" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M382.158 148.366L399.924 132.284L417.691 148.366V134.806L409.147 124.652L419.115 133.238L424.54 135.623L419.929 123.153L410.639 119.405L424.54 121.859L415.792 110.751L403.654 108.366L399.924 110.751L396.195 108.366L384.057 110.751L375.309 121.859L389.21 119.405L379.92 123.153L375.309 135.623L380.734 133.238L390.702 124.652L382.158 134.806V148.366Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M382.158 148.366L399.924 132.284L417.691 148.366V134.806L409.147 124.652L419.115 133.238L424.54 135.623L419.929 123.153L410.639 119.405L424.54 121.859L415.792 110.751L403.654 108.366L399.924 110.751L396.195 108.366L384.057 110.751L375.309 121.859L389.21 119.405L379.92 123.153L375.309 135.623L380.734 133.238L390.702 124.652L382.158 134.806V148.366Z"
      fill="#009B47"
    />
    <path
      d="M399.924 132.284L401.267 130.802L399.924 129.587L398.582 130.802L399.924 132.284ZM382.158 148.366H380.158V152.874L383.5 149.849L382.158 148.366ZM417.691 148.366L416.349 149.849L419.691 152.874V148.366H417.691ZM417.691 134.806H419.691V134.076L419.221 133.518L417.691 134.806ZM409.147 124.652L410.452 123.137L407.616 125.94L409.147 124.652ZM419.115 133.238L417.81 134.754L418.036 134.949L418.31 135.069L419.115 133.238ZM424.54 135.623L423.735 137.454L428.051 139.352L426.416 134.93L424.54 135.623ZM419.929 123.153L421.805 122.46L421.498 121.63L420.677 121.299L419.929 123.153ZM410.639 119.405L410.986 117.436L409.89 121.26L410.639 119.405ZM424.54 121.859L424.192 123.828L429.354 124.739L426.111 120.621L424.54 121.859ZM415.792 110.751L417.363 109.514L416.905 108.932L416.178 108.789L415.792 110.751ZM403.654 108.366L404.04 106.404L403.252 106.249L402.577 106.681L403.654 108.366ZM399.924 110.751L398.847 112.436L399.924 113.125L401.002 112.436L399.924 110.751ZM396.195 108.366L397.272 106.681L396.596 106.249L395.809 106.404L396.195 108.366ZM384.057 110.751L383.671 108.789L382.944 108.932L382.485 109.514L384.057 110.751ZM375.309 121.859L373.738 120.621L370.495 124.739L375.657 123.828L375.309 121.859ZM389.21 119.405L389.959 121.26L388.863 117.436L389.21 119.405ZM379.92 123.153L379.172 121.299L378.351 121.63L378.044 122.46L379.92 123.153ZM375.309 135.623L373.433 134.93L371.798 139.352L376.114 137.454L375.309 135.623ZM380.734 133.238L381.539 135.069L381.813 134.949L382.039 134.754L380.734 133.238ZM390.702 124.652L392.232 125.94L389.397 123.137L390.702 124.652ZM382.158 134.806L380.628 133.518L380.158 134.076V134.806H382.158ZM398.582 130.802L380.816 146.883L383.5 149.849L401.267 133.767L398.582 130.802ZM398.582 133.767L416.349 149.849L419.033 146.883L401.267 130.802L398.582 133.767ZM419.691 148.366V134.806H415.691V148.366H419.691ZM419.221 133.518L410.677 123.365L407.616 125.94L416.161 136.093L419.221 133.518ZM407.842 126.168L417.81 134.754L420.42 131.723L410.452 123.137L407.842 126.168ZM418.31 135.069L423.735 137.454L425.345 133.793L419.92 131.408L418.31 135.069ZM426.416 134.93L421.805 122.46L418.053 123.847L422.664 136.317L426.416 134.93ZM420.677 121.299L411.387 117.551L409.89 121.26L419.18 125.008L420.677 121.299ZM410.291 121.375L424.192 123.828L424.887 119.889L410.986 117.436L410.291 121.375ZM426.111 120.621L417.363 109.514L414.221 111.989L422.969 123.096L426.111 120.621ZM416.178 108.789L404.04 106.404L403.268 110.329L415.407 112.714L416.178 108.789ZM402.577 106.681L398.847 109.066L401.002 112.436L404.732 110.051L402.577 106.681ZM395.117 110.051L398.847 112.436L401.002 109.066L397.272 106.681L395.117 110.051ZM384.442 112.714L396.58 110.329L395.809 106.404L383.671 108.789L384.442 112.714ZM376.88 123.096L385.628 111.989L382.485 109.514L373.738 120.621L376.88 123.096ZM388.863 117.436L374.962 119.889L375.657 123.828L389.558 121.375L388.863 117.436ZM380.668 125.008L389.959 121.26L388.462 117.551L379.172 121.299L380.668 125.008ZM377.185 136.317L381.796 123.847L378.044 122.46L373.433 134.93L377.185 136.317ZM379.929 131.408L374.504 133.793L376.114 137.454L381.539 135.069L379.929 131.408ZM389.397 123.137L379.429 131.723L382.039 134.754L392.007 126.168L389.397 123.137ZM383.688 136.093L392.232 125.94L389.172 123.365L380.628 133.518L383.688 136.093ZM384.158 148.366V134.806H380.158V148.366H384.158Z"
      fill="black"
      mask="url(#path-42-outside-6)"
    />
    <path
      d="M373.309 271.725V271.31L373.016 271.017L364.193 262.194L363.9 261.901H363.486H351.133H350.718L350.426 262.194L341.602 271.017L341.309 271.31V271.725V280.548V281.548H342.309H372.309H373.309V280.548V271.725Z"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <rect x="342.309" y="271.901" width="30" height="8.64706" fill="#986F4D" />
    <mask
      id="path-46-outside-7"
      maskUnits="userSpaceOnUse"
      x="315.309"
      y="256.366"
      width="50"
      height="27"
      fill="black"
    >
      <rect fill="white" x="315.309" y="256.366" width="50" height="27" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M340.309 272.366L331.218 262.366V272.366H320.309L328.491 280.548H340.309H352.127L360.309 272.366H349.4V262.366L340.309 272.366Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M340.309 272.366L331.218 262.366V272.366H320.309L328.491 280.548H340.309H352.127L360.309 272.366H349.4V262.366L340.309 272.366Z"
      fill="#009B47"
    />
    <path
      d="M331.218 262.366L332.698 261.021L329.218 257.193V262.366H331.218ZM340.309 272.366L338.829 273.712L340.309 275.339L341.789 273.712L340.309 272.366ZM331.218 272.366V274.366H333.218V272.366H331.218ZM320.309 272.366V270.366H315.481L318.895 273.78L320.309 272.366ZM328.491 280.548L327.077 281.962L327.662 282.548H328.491V280.548ZM352.127 280.548V282.548H352.956L353.541 281.962L352.127 280.548ZM360.309 272.366L361.723 273.78L365.138 270.366H360.309V272.366ZM349.4 272.366H347.4V274.366H349.4V272.366ZM349.4 262.366H351.4V257.193L347.92 261.021L349.4 262.366ZM329.738 263.712L338.829 273.712L341.789 271.021L332.698 261.021L329.738 263.712ZM333.218 272.366V262.366H329.218V272.366H333.218ZM320.309 274.366H331.218V270.366H320.309V274.366ZM329.905 279.134L321.723 270.952L318.895 273.78L327.077 281.962L329.905 279.134ZM340.309 278.548H328.491V282.548H340.309V278.548ZM340.309 282.548H352.127V278.548H340.309V282.548ZM353.541 281.962L361.723 273.78L358.895 270.952L350.713 279.134L353.541 281.962ZM360.309 270.366H349.4V274.366H360.309V270.366ZM351.4 272.366V262.366H347.4V272.366H351.4ZM347.92 261.021L338.829 271.021L341.789 273.712L350.88 263.712L347.92 261.021Z"
      fill="black"
      mask="url(#path-46-outside-7)"
    />
    <rect
      x="304.309"
      y="442.366"
      width="28"
      height="8"
      transform="rotate(90 304.309 442.366)"
      fill="#986F4D"
      stroke="black"
      strokeWidth="2"
      id="node-signpost"
    />
    <rect
      x="286.309"
      y="441.366"
      width="28"
      height="18"
      fill="#CA9B71"
      stroke="black"
      strokeWidth="2"
      id="node-signpost"
    />
    <rect
      x="291.309"
      y="445.369"
      width="18"
      height="2"
      fill="black"
      {...passThroughClicks}
    />
    <rect
      x="291.309"
      y="449.366"
      width="18"
      height="2"
      fill="black"
      {...passThroughClicks}
    />
    <rect
      x="291.309"
      y="453.364"
      width="18"
      height="2"
      fill="black"
      {...passThroughClicks}
    />
    <path
      d="M290.733 445.377L286.705 444.36V446.415L290.733 445.377Z"
      fill="black"
      {...passThroughClicks}
    />
    <path
      d="M309.686 455.349L313.714 456.366L313.714 454.311L309.686 455.349Z"
      fill="black"
      {...passThroughClicks}
    />
    <path
      d="M430.309 400.366L429.309 350.366H431.309L430.309 400.366Z"
      fill="black"
    />
    <path
      d="M330.309 598.366L329.309 548.366H331.309L330.309 598.366Z"
      fill="black"
    />
    <path
      d="M170.309 599.234L169.309 549.234H171.309L170.309 599.234Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M200.309 720.366C200.309 709.321 191.355 700.366 180.309 700.366L100.309 700.366L100.309 620.366C100.309 609.32 91.3548 600.366 80.3091 600.366L20.3091 600.366C9.2634 600.366 0.309099 609.32 0.309098 620.366L0.309089 720.366L0.309084 780.366C0.309083 790.333 7.5992 798.597 17.1379 800.116C18.1707 800.281 19.2299 800.366 20.3091 800.366L80.3091 800.366L180.309 800.366C191.355 800.366 200.309 791.412 200.309 780.366L200.309 720.366Z"
      fill="black"
      fillOpacity="0.07"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M220.309 0.366215C209.263 0.366216 200.309 9.32053 200.309 20.3662L200.309 100.366L120.309 100.366C109.263 100.366 100.309 109.321 100.309 120.366L100.309 180.366C100.309 191.412 109.263 200.366 120.309 200.366L220.309 200.366L280.309 200.366C290.276 200.366 298.539 193.076 300.059 183.537C300.224 182.505 300.309 181.445 300.309 180.366L300.309 120.366L300.309 20.3662C300.309 9.32052 291.355 0.366211 280.309 0.366211L220.309 0.366215Z"
      fill="black"
      fillOpacity="0.07"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M500.309 370.366C500.309 359.321 509.263 350.366 520.309 350.366H580.309C591.355 350.366 600.309 359.321 600.309 370.366V530.366C600.309 541.412 591.355 550.366 580.309 550.366H550.309H520.309H500.309V630.366C500.309 641.412 491.355 650.366 480.309 650.366H420.309C409.263 650.366 400.309 641.412 400.309 630.366V470.366C400.309 459.321 409.263 450.366 420.309 450.366H450.309H480.309H500.309V370.366Z"
      fill="black"
      fillOpacity="0.07"
    />
  </svg>
);

ScratchIsland.propTypes = {
  windowDimensions: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
    zoom: PropTypes.number,
  }),
  scale: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

export default ScratchIsland;
